import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';

class ActiveDirectoryApi extends CollectionApi {
  constructor() {
    super('/api/v2/activedirectories', {
      skip: 0,
      limit: 100,
      sort: 'domain', // Prepend with a '-' to reverse default sort direction
      filter: [{
        name: 'domain',
        operator: 'search',
        value: '',
      }],
    });
  }

  fetchAllAgents(id) {
    return this.getAllItems(`${this.baseUrl}/${id}/agents`);
  }

  fetchAllUserGroups(id) {
    return this.getAllItems(`${this.baseUrl}/${id}/usergroups`);
  }

  createAdBridgeSyncAgent(id) {
    const url = `${this.baseUrl}/${id}/agents`;

    return this
      .initialize()
      .then(() => axios.post(url, {}))
      .then(resp => resp.data);
  }
}

export default new ActiveDirectoryApi();
